var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { IThumbUpFill, IThumbDownFill, IThumbUp, IThumbDown, Button } from '@ideagen/helix-react-core';
import { useTranslation } from 'react-i18next';
import { HELIX_REACT_AI_TRANSLATION_NAMESPACE } from '../../../locales';
import { sendFeedback } from '../../DraggableContainer/draggablecontainer.api';
export const FeedbackButton = ({ buttonType, threadId, dataId, onFeedbackSent, disabled = false, isSelected = false, auth, baseUrl, }) => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const handleFeedbackSubmission = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        try {
            const result = yield sendFeedback(threadId, buttonType === 'like', auth, baseUrl);
            if (result.success) {
                // Success - notify parent component
                onFeedbackSent(buttonType);
            }
            else {
                console.error('Feedback submission failed:', result.error);
                // Keep buttons clickable for retry
            }
        }
        catch (error) {
            console.error('Error sending feedback:', error);
            // Keep buttons clickable for retry
        }
        finally {
            setIsLoading(false);
        }
    });
    const getIcon = () => {
        if (buttonType === 'like') {
            return isSelected ? _jsx(IThumbUpFill, {}) : _jsx(IThumbUp, {});
        }
        else {
            return isSelected ? _jsx(IThumbDownFill, {}) : _jsx(IThumbDown, {});
        }
    };
    return (_jsx(Button, { dataId: dataId, leftIcon: getIcon(), onClick: handleFeedbackSubmission, loading: isLoading, title: buttonType === 'like'
            ? t('commands.like', { ns: HELIX_REACT_AI_TRANSLATION_NAMESPACE })
            : t('commands.dislike', { ns: HELIX_REACT_AI_TRANSLATION_NAMESPACE }), type: "universal", variant: "grey", disabled: disabled || isLoading }));
};
